export default () => ({
  paginationContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  pagination: {
    borderBottom: 0,
  },
  paginationSelect: {
    minWidth: '50px',
  },
});
